import { Component, Output, EventEmitter } from '@angular/core';

import { TranslateService } from '@ngstack/translate';

@Component({
  selector: 'app-options',
  templateUrl: './options.component.html'
})
export class OptionsComponent {

  currentLang = 'fa';
  showSettings = false;
  options = {
    collapsed: false,
    compact: false,
    boxed: false,
    dark: false,
    dir: 'rtl'
  };

  @Output() messageEvent = new EventEmitter<Object>();

  constructor(
    public translate: TranslateService) {
    //const browserLang: string = translate.getBrowserLanguage();
    //translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
  }

  sendOptions() {
    if (this.options.collapsed === true ) {
      this.options.compact = false;
    }
    if (this.options.compact === true ) {
      this.options.collapsed = false;
    }
    this.messageEvent.emit(this.options);
  }
}
